import type { RegisteredRouter } from "@tanstack/react-router";
import type { RouteToPath } from "@tanstack/router-core";
import { useCallback } from "react";

import { useMatchRouteWithExact } from "./useMatchRouteWithExact";

type RegisteredRoutePath = RouteToPath<RegisteredRouter>;

/**
 * Like React Router's `useRouteMatch(string[])`: tries each path in order and
 * returns the first match from {@link useMatchRouteWithExact}, or `null`.
 */
export const useMatchAnyRoute = () => {
  const matchRouteWithExact = useMatchRouteWithExact();

  return useCallback(
    <const TPaths extends readonly RegisteredRoutePath[]>(paths: TPaths) => {
      for (const path of paths) {
        const match = matchRouteWithExact(path);
        if (match) {
          return {
            path,
            params: match.params,
            get isExact() {
              return match.isExact;
            },
          };
        }
      }

      return null;
    },
    [matchRouteWithExact],
  );
};
